import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { HttpService, UtilityService } from '.';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class XchangeratesService {

  private currencySubject = new BehaviorSubject<any>(null);
  currency$ = this.currencySubject.asObservable();

  constructor(private http: HttpService, private util: UtilityService) { 
    const selected = this.safeParse('currency_List_Selected');
    if (selected) {
      this.currencySubject.next(selected);
      return;
    }
  
    const list = this.safeParse('currency_List');
    if (Array.isArray(list) && list.length) {
      this.currencySubject.next(list[0]);
    }
  }

  currencyList() {
    forkJoin({
      currency: this.http.flightsave('apiV2/page/supportedcurrency', ''),
      rates: this.http.flightsave('apiV2/page/xchangerates', '')
    }).subscribe({
      next: ({ currency, rates }) => {
        if (currency.statusCode !== 200 || rates.statusCode !== 200) return;

        const combined = currency.data.map(c => ({
          ...c,
          rate: rates.data[c.shortname] ?? 0
        }));

        localStorage.setItem('currency_List', JSON.stringify(combined));

        const active =
          this.safeParse('currency_List_Selected') ?? combined[0];

        this.currencySubject.next(active);
      },
      error: err => this.util.errorMessage(err)
    });
  }

  getCurrency() {
    return this.currencySubject.value;
  }

  pushCurrencyActive(data: any) {
    localStorage.setItem('currency_List_Selected', JSON.stringify(data));
    this.currencySubject.next(data);
  }

  private safeParse(key: string) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }
}
